import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import styles from './styles';
import { images } from '~/themes/variables';
const Div = styled.div `
  ${styles}
`;
const Footer = () => {
    return (_jsxs(Div, { children: [_jsx("div", { className: "column copyright", children: _jsxs("a", { href: "https://oneroomstreaming.com", target: "_blank", rel: "noreferrer", className: "brand link", children: [_jsx("div", { children: "Lovingly powered by" }), _jsx("img", { src: images.logo, alt: "OneRoom" })] }) }), _jsxs("div", { className: "column links", children: [_jsx("a", { title: "Terms & Conditions", href: "https://oneroomstreaming.com/terms-and-conditions", target: "_blank", rel: "noreferrer", children: "Terms & Conditions" }), _jsx("a", { title: "Privacy Policy", href: "https://www.oneroomstreaming.com/privacy-policy", target: "_blank", rel: "noreferrer", children: "Privacy Policy" })] })] }));
};
Footer.propTypes = {};
export default Footer;
